import { Directive, Input, OnChanges, OnDestroy, Optional, SimpleChanges, SkipSelf } from '@angular/core';
import { CollabApiService } from '@portal-core/collab/services/collab-api.service';
import { ProjectFilesTreeComponent } from '@portal-core/project-files/components/project-files-tree/project-files-tree.component';
import { ProjectFolder } from '@portal-core/project-files/enums/project-folder.enum';
import { ProjectFilesTreeDataProvider } from '@portal-core/project-files/services/project-files-tree-data-provider';
import { ProjectFilesService } from '@portal-core/project-files/services/project-files.service';
import { WorkspaceFilters } from '@portal-core/workspaces/models/workspace-filters.model';
import { WorkspaceFilesDataProvider } from '@portal-core/workspaces/services/workspace-files-data-provider';
import { WorkspaceFilesService } from '@portal-core/workspaces/services/workspace-files/workspace-files.service';
import { Observable, Subscription } from 'rxjs';

@Directive({
  selector: 'mc-project-files-tree[mcWorkspaceTree]',
  providers: [
    {
      provide: ProjectFilesTreeDataProvider,
      useFactory: (parentProvider: ProjectFilesTreeDataProvider, collabApiService: CollabApiService, workspaceFilesService: WorkspaceFilesService) => {
        return parentProvider ?? new WorkspaceFilesDataProvider(collabApiService, workspaceFilesService);
      },
      deps: [
        [new Optional(), new SkipSelf(), ProjectFilesTreeDataProvider],
        CollabApiService,
        WorkspaceFilesService
      ]
    }
  ]
})
export class WorkspaceTreeDirective implements OnChanges, OnDestroy {
  @Input() filters: Observable<WorkspaceFilters>;

  private filtersSubscription: Subscription;

  constructor(
    private host: ProjectFilesTreeComponent,
    private projectFilesService: ProjectFilesService,
    private dataProvider: ProjectFilesTreeDataProvider, // useFactory: result - real data provider
    @Optional() @SkipSelf() private parentDataProvider: ProjectFilesTreeDataProvider // deps: result - parent data provider
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filters']) {
      this.filtersSubscription?.unsubscribe();
      this.filtersSubscription = null;

      if (this.filters) {
        this.filtersSubscription = this.filters.subscribe(filters => {
          if (this.host.fileFilterType === filters?.fileTypeFilter && this.host.committedFilter === filters?.fileStatusFilter) {
            return;
          }

          this.host.committedFilter = filters?.fileStatusFilter;

          if (filters?.fileTypeFilter || typeof this.host.committedFilter === 'boolean') {
            if (filters.fileTypeFilter) {
              this.host.fileFilterType = filters.fileTypeFilter;
              this.host.fileFilter = this.projectFilesService.fileTypes[filters.fileTypeFilter].filter;
              this.host.rootFolder = this.projectFilesService.fileTypes[filters.fileTypeFilter].restrictedToFolder;
            } else {
              this.host.fileFilterType = null;
              this.host.fileFilter = null;
              this.host.rootFolder = ProjectFolder.Root;
            }

            setTimeout(() => this.host.changeRootFolder(this.host.rootFolder, this.host.fileFilter), 0);
          }
        });
      }
    }
  }

  ngOnDestroy() {
    this.filtersSubscription?.unsubscribe();

    // dispose the data provider only when this directive's factory created it
    if (this.dataProvider !== this.parentDataProvider) {
      this.dataProvider.dispose();
    }
  }
}
